const findSeparator = (input: string): string | null => {
  let separator: string | null = null;
  const containsQuotes = input.includes('"'); // Vérifier la présence de guillemets

  if (containsQuotes) {
    // Vérification spécifique si les guillemets sont présents
    for (let i = 0; i < input.length - 2; i++) {
      if (input[i] === '"' && input[i + 1] === ',' && input[i + 2] === '"') {
        separator = ',';
        break;
      } else if (input[i] === '"' && input[i + 1] === '|' && input[i + 2] === '"') {
        separator = '|';
        break;
      }
    }
  }

  if (!separator) {
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
      if (char === ',' || char === '|') {
        separator = char;
        break;
      }
    }
  }

  return separator;
};

const isCommaSeparator = (str: string): boolean => {
  return findSeparator(str) === ',';
};

const haveSeparator = (str: string): boolean => findSeparator(str) === ',' || findSeparator(str) === '|';

const joinCommaSeparator = (strs: string[]): string => {
  // Faut vérifier si les choix sélectionnés contiennent une virgule
  return strs
    .map((str: string) => {
      // Le cas où il n'y a pas ni guillemets ni simple quotes
      if (!str.includes("'") && !str.includes('"')) return `"${str}"`;

      // Et les 2 cas tordus....
      if (str.includes("'") && !str.includes('"')) return `"${str}"`;
      if (!str.includes("'") && str.includes('"')) return `'${str}'`;

      // Le cas le plus simple
      if (!str.includes(',')) return str;

      return '';
    })
    .join(',');
};

const joinPipeSeparator = (strs: string[]): string => {
  // Faut vérifier si les choix sélectionnés contiennent une virgule
  return strs
    .map((str: string) => {
      // Le cas où il n'y a pas ni guillemets ni simple quotes
      if (!str.includes("'") && !str.includes('"')) return `"${str}"`;

      // Et les 2 cas tordus....
      if (str.includes("'") && !str.includes('"')) return `"${str}"`;
      if (!str.includes("'") && str.includes('"')) return `'${str}'`;

      // Le cas le plus simple
      if (!str.includes('|')) return str;

      return '';
    })
    .join('|');
};

const splitCommaSeparator = (str?: string): string[] => {
  if (!str) return [];

  const result: string[] = [];
  let currentSegment = '';

  let insideQuotes = false;
  let quoteType: string | null = null;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === '"' || char === "'") {
      if (quoteType === null) {
        // Si nous trouvons un guillemet, basculer l'état insideQuotes
        insideQuotes = !insideQuotes;
        quoteType = char;
      } else if (quoteType === char) {
        insideQuotes = !insideQuotes;
        quoteType = null;
      } else {
        currentSegment += char;
      }
    } else if (char === ',' && !insideQuotes) {
      // Si nous trouvons une virgule en dehors des guillemets, ajouter le segment actuel à la liste des résultats
      result.push(currentSegment.trim());
      currentSegment = '';
    } else {
      // Sinon, ajouter le caractère au segment actuel
      currentSegment += char;
    }
  }

  // Ajouter le dernier segment à la liste des résultats
  result.push(currentSegment.trim());

  return result;
};

const splitPipeSeparator = (str?: string): string[] => {
  if (!str) return [];

  const result: string[] = [];
  let currentSegment = '';

  let insideQuotes = false;
  let quoteType: string | null = null;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === '"' || char === "'") {
      if (quoteType === null) {
        // Si nous trouvons un guillemet, basculer l'état insideQuotes
        insideQuotes = !insideQuotes;
        quoteType = char;
      } else if (quoteType === char) {
        insideQuotes = !insideQuotes;
        quoteType = null;
      } else {
        currentSegment += char;
      }
    } else if (char === '|' && !insideQuotes) {
      // Si nous trouvons une virgule en dehors des guillemets, ajouter le segment actuel à la liste des résultats
      result.push(currentSegment.trim());
      currentSegment = '';
    } else {
      // Sinon, ajouter le caractère au segment actuel
      currentSegment += char;
    }
  }

  // Ajouter le dernier segment à la liste des résultats
  result.push(currentSegment.trim());

  return result;
};

export {
  splitCommaSeparator,
  splitPipeSeparator,
  joinCommaSeparator,
  joinPipeSeparator,
  isCommaSeparator,
  haveSeparator,
};
